import Content from "components/Content";
import Label from "components/Label";
import ScrollStepper from "components/ScrollStepper";
import React, { FC, useState } from "react";
import Media from "components/Media";
import ScrollView from "components/ScrollView";
import { useTheme } from "theme/ThemeCreator";
import AnimatedMandala from "components/AnimatedMandala";
import Shape8 from "../../../../../public/shape-8.svg";

import Van from "../../../../../public/services-van.png";
import styles from "./styles.module.scss";
import { steps } from "./constants";
import StepMandala from "./components/StepMandala";

const Heading: FC = () => {
  const { colors } = useTheme();
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} variant="h1-centered" color="primary">
        Your home deserves to be loved
      </Label>
      <Label className={styles.subtitle} variant="s2-centered" color="primary">
        Our service is simple — we pair you with a Home Coordinator, who manages
        all of your day-to-day home tasks. They pair with your Local Expert to
        provide you on-the-ground support, big and small.
      </Label>
      <img alt="" src={Van.src} className={styles.van} />
      <div className={styles.bottom}>
        <div className={styles.leftPanel}>
          <Label className={styles.leftPanelTitle} variant="h2" color="primary">
            Meet your Humming Homes team
          </Label>
          <Media at={["desktop", "tablet"]}>
            <ScrollStepper onStepChange={setCurrentStep} steps={steps} />
          </Media>
          <Media at={["mobile"]}>
            <ScrollView
              colors={{ indicatorColor: colors.supplementalVariant1 }}
              itemWidth={100}
            >
              {steps.map(({ title, description }) => (
                <div className={styles.item}>
                  <Label
                    className={styles.itemTitle}
                    variant="centered-h2"
                    color="primary"
                  >
                    {title}
                  </Label>
                  <Label variant="centered" color="primary">
                    {description}
                  </Label>
                </div>
              ))}
            </ScrollView>
          </Media>
        </div>
        <div className={styles.rightPanel}>
          <Media className={styles.spinningMandala} at={["desktop", "tablet"]}>
            <AnimatedMandala
              when="infinite"
              width={550}
              height={550}
              layers={[
                {
                  Component: Shape8,
                  width: 550,
                  height: 550,
                  componentProps: {
                    className: styles.evenMandala
                  }
                },
                {
                  motion: false,
                  Component: StepMandala,
                  width: 380,
                  height: 380,
                  componentProps: {
                    index: currentStep
                  }
                }
              ]}
            />
          </Media>
        </div>
      </div>
    </Content>
  );
};

export default Heading;
